export default "__VITE_PUBLIC_ASSET__2fb846e1__"